var postal = require("./PubSub");

function sendMenuEntryRequest(menuType, title, callback, weight) {
    var channel = postal.channel("RootController");

    return channel.request({
        topic : "add-" + menuType + "-menu-entry",
        data : {
            title : title,
            handler : callback,
            weight : weight
        }
    }).then(
        function(data) {
            return data.$entry;
        },
        function(err) {
            console.error("Unable to register " + menuType + " menu " + title + ": " + err);
        }
    );
}

var Plugin = {
    addOptionsMenuEntry : function(title, callback, weight) {
        return sendMenuEntryRequest("options", title, callback, weight);
    },

    addPreAuthMenuEntry : function(title, callback, weight) {
        return sendMenuEntryRequest("pre-auth", title, callback, weight);
    },

    registerController : function(controller) {
        var channel = postal.channel("RootController");
        channel.publish("register-controller", {controller : controller});
    }
};

module.exports = Plugin;